import { MToolboxPermit } from './toolbox-permit.model';
import { Toolbox } from '../interfaces/Organization';

export class MToolbox{
    id: number;
    name: string;
    url: string;
    toolboxPermits: MToolboxPermit[];

    constructor (toolbox: Toolbox){
        this.id = toolbox.id;
        this.name = toolbox.nombre;
        this.url = toolbox.url;
        this.toolboxPermits = []
        for (let i = 0; i < toolbox.permiso_toolboxes.length; i++) {
            this.toolboxPermits.push(new MToolboxPermit(toolbox.permiso_toolboxes[i]))
        }
    }
}
export const IdToolboxMAIL = 2;
export const IdToolboxSIENI = 1;
export const IdToolboxPANEL = 0;
export const IdToolboxGID = 5;
export const IdToolboxNC = 6;
